module.exports = __webpack_public_path__ + "static/browser-3-c6a1a0068d32b88a961fa92fef4c58c4.webp";